import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container, Paper, TextField, Button, Typography,
  CircularProgress, Snackbar
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import { signIn } from "../redux/session.action";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
  },
  paper: { padding: theme.spacing(4), width: 400 },
  form: { marginTop: theme.spacing(2) },
  submit: { marginTop: theme.spacing(3) },
}));

export default function LoginPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { isLoading, error } = useSelector((state) => state.session);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(signIn({ email, password }));
    if (result.success) {
      history.push("/portal");
    }
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <Paper className={classes.paper} elevation={3}>
          <Typography variant="h5" align="center" gutterBottom>Partner Portal</Typography>
          <Typography variant="body2" align="center" color="textSecondary">Sign in to your partner account</Typography>
          <form className={classes.form} onSubmit={handleSubmit}>
            <TextField fullWidth label="Email" type="email" margin="normal" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <TextField fullWidth label="Password" type="password" margin="normal" variant="outlined" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <Button fullWidth type="submit" variant="contained" color="primary" className={classes.submit} disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} /> : "Sign In"}
            </Button>
          </form>
        </Paper>
        <Snackbar open={!!error} autoHideDuration={5000}>
          <Alert severity="error">{error}</Alert>
        </Snackbar>
      </Container>
    </div>
  );
}
